import { FC } from 'react';
import PDFTablePage from '../../../themed/pdf/pdfTablePage';

import classNames from '../pdf.module.scss';
import * as models from '../../../../utils/models';

interface HNDSExtended extends models.HelideckNetDropSummary {
	weightLabel: string;
	totalLabel: string;
	passedLabel: string;
	failedLabel: string;
	summaryData: models.HelideckSummaryItem[];
}

const HelideckNetDropSummarySheet: FC<HNDSExtended> = (props): JSX.Element => {
	return (
		<div className={classNames['visual-inspection']}>
			<div className={classNames['visual-inspection-body']}>
				<div className={classNames['visual-inspection-body-header-warning']}>
					Result
				</div>
				<div className={classNames['visual-inspection-body-body']}>
					<p>
						{props.weightLabel}: {props.shellWeight}
					</p>
					<p>
						{props.totalLabel}: {props.numberOfNetTotal}
					</p>
					<p className={classNames.success}>
						{props.passedLabel}: {props.numberOfNetPassed}
					</p>
					<p className={classNames.danger}>
						{props.failedLabel}: {props.numberOfNetFailed}
					</p>
				</div>
			</div>
			<div className={classNames['visual-inspection-body']}>
				<div className={classNames['visual-inspection-body-header-warning']}>
					Finding
				</div>
				<div className={classNames['visual-inspection-body-body']}>
					<p>{props.general}</p>
				</div>
			</div>
			<div className={classNames['visual-inspection-body']}>
				<div className={classNames['visual-inspection-body-header-danger']}>
					Remarks & Recommendations:
				</div>
				<div className={classNames['visual-inspection-body-body']}>
					<p>{props.remarks}</p>
				</div>
			</div>

			<div className="border-horizontal-light">
				<PDFTablePage columns={summaryColumns} data={props.summaryData} />
			</div>
		</div>
	);
};

const summaryColumns: models.Column[] = [
	{
		path: 'description',
		label: 'Description',
		style: () => ({ textAlign: 'left' }),
	},
	{ path: 'photoRef', label: 'Photo Ref' },
];

export default HelideckNetDropSummarySheet;
